import { useController } from '@framework/form/hooks/useController.ts';
import { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../tree/references/TreeReferencesContext.tsx';
import { ComputeExpressionBaseInput } from './ComputeExpressionBaseInput.tsx';

export interface IComputeExpressionInputProps {
  name: string;
  widgetId: string;
  /** Se true, include la reference al widget stesso tra quelle selezionabili */
  includeSelf: boolean;
  noFunctions?: boolean;
}

/**
 * Input per la gestione dell'espressione di calcolo
 * tramite l'editor Tiptap
 */
export function ComputeExpressionInput(props: IComputeExpressionInputProps) {
  const { widgetId, includeSelf } = props;
  const {
    field: { value, onChange, onBlur },
  } = useController(props.name);

  const { references } = useTreeReferencesContext();

  const inputReferences = useMemo(() => {
    return references.filter(r => {
      if (r.id === widgetId) {
        return includeSelf;
      }
      return true;
    });
  }, [includeSelf, references, widgetId]);

  return (
    <ComputeExpressionBaseInput
      references={inputReferences}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      noFunctions={props.noFunctions}
    />
  );
}
